import {resolveCompatibleGroupIdxForActivo} from './formActivoCompatibility.js';
import {legacyPositiveId} from './legacyRecoverySources.js';

// Solo lee el catálogo ya preparado. No descarga, reemplaza ni limpia copias
// durante una recuperación; una autorización/copia faltante mantiene el bloqueo.
export async function inspectLegacyAssetReferences({context, drafts, operations, user, readCatalog}) {
    const snapshot = drafts[0]?.payload || context.visita, refs = new Map(), branch = Number(context.visita.sucursal_id);
    for (const [key, value] of Object.entries(snapshot.custom_subgroup_names || {})) {
        const match = key.match(/^_activo_id_(\d+_\d+)$/);
        if (!match) continue;
        if (!legacyPositiveId(value)) throw Error('La relación anterior del activo requiere recuperación explícita.');
        refs.set(match[1], legacyPositiveId(value));
    }
    for (const operation of operations) {
        const payload = typeof operation.payload === 'string' ? JSON.parse(operation.payload) : operation.payload;
        if (payload?.activo_id != null && refs.get(payload.local_instance_key) !== legacyPositiveId(payload.activo_id))
            throw Error('El activo del alta y del borrador no coinciden. Se conservan para revisión.');
    }
    if (!refs.size) return null;
    if (!readCatalog) throw Error('Falta verificar el catálogo autorizado de los activos anteriores. La migración sigue pendiente.');
    {
        const result = await readCatalog(branch);
        if (!result?.available || result.verified !== true || !result.version || !result.sha256)
            throw Error('Falta una copia verificada y autorizada del catálogo de activos. La migración queda pendiente sin reemplazar datos.');
        const assets = [];
        for (const [instance, id] of refs) {
            const asset = result.activos.find(item => Number(item.id) === id), group = instance.split('_')[0];
            if (!asset || Number(asset.empresa_id) !== Number(user.empresa_id) || Number(asset.sucursal_id) !== branch
                || resolveCompatibleGroupIdxForActivo(context.template, asset, group) !== group)
                throw Error('El activo anterior no está autorizado para esta empresa, sucursal y grupo. Se conserva sin reasignarlo.');
            assets.push({instance, id, baseProductoId: Number(asset.base_producto_id)});
        }
        return {sucursalId: branch, version: result.version, sha256: result.sha256, assets};
    }
}
